export default __webpack_public_path__ + "static/media/undraw_add_file2.gvbb.29be1603.svg";